import React, { Fragment, useState, useEffect } from "react";
import {
  Form,
  Input,
  Button,
  Layout,
  Row,
  Col,
  Card,
  Breadcrumb,
  message,
} from "antd";
import { Link, Redirect } from "react-router-dom";

import Axios from "axios";
import { url } from "../../config/global";
import moment from "moment";

const { Content } = Layout;

const layout = {
  labelCol: {
    lg: 8,
    md: 10,
  },
  wrapperCol: {
    lg: 8,
    md: 14,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 8,
    span: 16,
  },
};

function EditSPDetailsMaterialOrder(props) {
  const [data, setData] = useState({
    purchase_order: "",
    component_item: "",
    qty_order: "",
    qads: [],
  });

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    Axios.get(`${url}/master-material-order/manual/${props.match.params.id}`, {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    })
      .then((res) => {
        setData({
          ...data,
          purchase_order: res.data.data.purchase_order,
          component_item: res.data.data.component_item,
          qty_order: res.data.data.qty_order,
        });
      })
      .catch((err) => {
        if (err.response) {
          message.error(err.response.data.message);
          if (err.response.status === 401) {
            sessionStorage.removeItem("token");
          }
        }
      });
  };

  const handleChange = (name, value) => {
    setError(null);
    setData({
      ...data,
      [name]: value,
    });
  };

  const onSaveData = () => {
    setLoading(true);

    let fd = new FormData();
    fd.set("purchase_order", data.purchase_order);
    fd.set("component_item", data.component_item);
    fd.set("qty_ordered", data.qty_order);

    Axios.post(
      `${url}/master-material-order/manual/${props.match.params.id}`,
      fd,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      }
    )
      .then((res) => {
        message.success(res.data.message);
        props.history.push("/material-order");
      })
      .catch((err) => {
        if (err.response) {
          message.error(err.response.data.message);
          if (err.response.status === 422) {
            setError(err.response.data.errors);
          }
          if (err.response.status === 401) {
            sessionStorage.removeItem("token");
          }
        }
        setLoading(false);
      });
  };

  const handleReset = () => {
    setData({
      purchase_order: "",
      component_item: "",
      qty_order: "",
    });
  };

  if (!sessionStorage.getItem("token")) {
    return <Redirect to="/login" />;
  }

  return (
    <Fragment>
      <Row>
        <Col xs={24}>
          <Card
            type="inner"
            title="Material Order"
            extra={moment(new Date()).format("DD MMMM YYYY")}
          >
            <Row type="flex" justify="left">
              <Breadcrumb>
                <Breadcrumb.Item>
                  <Link to="/material-order">Kembali</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>Manual Order</Breadcrumb.Item>
              </Breadcrumb>
            </Row>
          </Card>
        </Col>
      </Row>
      <Content className="content">
        <Row>
          <Col xs={24}>
            <Card className="body-data">
              <Form {...layout} name="control-hooks" onFinish={onSaveData}>
                <Form.Item
                  validateStatus={
                    error && error.purchase_order ? "error" : false
                  }
                  help={
                    error && error.purchase_order
                      ? error.purchase_order[0]
                      : false
                  }
                  label="Purchase Order"
                >
                  <Input
                    disabled
                    value={data.purchase_order}
                    onChange={(e) =>
                      handleChange("purchase_order", e.target.value)
                    }
                  />
                </Form.Item>
                <Form.Item
                  validateStatus={
                    error && error.component_item ? "error" : false
                  }
                  help={
                    error && error.component_item
                      ? error.component_item[0]
                      : false
                  }
                  label="Component Item"
                >
                  <Input
                    disabled
                    value={data.component_item}
                    onChange={(e) => {
                      handleChange("component_item", e.target.value);
                    }}
                  />
                </Form.Item>
                <Form.Item
                  validateStatus={error && error.qty_order ? "error" : false}
                  help={error && error.qty_order ? error.qty_order[0] : false}
                  label="Qty Daily Order"
                >
                  <Input 
                    value={data.qty_order}
                    onChange={(e) => {
                      handleChange("qty_order", e.target.value);
                    }}
                  />
                </Form.Item>

                <Form.Item {...tailLayout}>
                  <Button
                    loading={loading}
                    type="primary"
                    htmlType="submit"
                    className="mr-button"
                  >
                    Submit
                  </Button>
                  <Button htmlType="reset" onClick={handleReset}>
                    Reset
                  </Button>
                </Form.Item>
              </Form>
            </Card>
          </Col>
        </Row>
      </Content>
    </Fragment>
  );
}

export default EditSPDetailsMaterialOrder;
